import React from 'react'
import styled from 'styled-components'

import { ResourceCoreData } from 'dataHooks/types'
import { displayOwner, truncateDescription } from 'utilities/language'
import { Tags } from 'components/ui'
import TemplateLink from 'components/navigation/TemplateLink'
import device from 'utilities/device'

interface MarginProps {
  margin?: boolean
}
const ResourceContainer = styled.section<{ expanded: boolean }>`
  background: ${({ theme }) => theme.backgroundAlternate};
  padding: 20px;
  display: grid;
  grid-template-areas:
    'title'
    'author'
    'summary';
  grid-template-rows: auto 1fr;
  border-bottom: 1px solid ${({ theme }) => theme.neutral2};

  ${props =>
    props.expanded &&
    `grid-template-areas:
      "title author summary"
      'title author tags';
    grid-template-columns: 1fr 1fr 2fr;
    column-gap: 30px;
    row-gap: 15px;
    border-bottom: 1px solid  ${props.theme.neutral2};
    @media ${device.tablet}{
      grid-template-areas:
        "title"
        "author"
        "summary"
        "tags";
      grid-template-columns: 1fr;
    }
  `}
  @media (max-width: 1280px) {
    ${props => !props.expanded && 'display: none;'}
  }
`
const Title = styled(TemplateLink)`
  grid-area: title;
  ${({ theme }) => theme.textStyleH5};
  color: ${({ theme }) => theme.links};
  &:hover {
    text-decoration: underline;
  }
`
const Author = styled.p<MarginProps>`
  grid-area: author;
  color: ${({ theme }) => theme.neutral1};
  ${({ theme }) => theme.textStyleH6};
  line-height: 1.3em;
  ${props => props.margin && 'margin-top: 1rem'};
`
const Description = styled.p<MarginProps>`
  grid-area: summary;
  font-size: 14px;
  font-family: 'Open Sans', Arial, Helvetica, sans-serif;
  line-height: 1.3em;
  ${props => props.margin && 'margin-top: 1rem'};
  color: ${({ theme }) => theme.text};
`
const TagContainer = styled.div`
  grid-area: tags;
`

const ResourcePreview: React.FC<ResourceCoreData & { expand: boolean }> = ({
  data,
  expand,
}) => {
  return (
    <ResourceContainer expanded={expand}>
      <Title data={data} openInNewTab={true}>
        {data.Title}
      </Title>
      <Author margin={!expand}>{displayOwner(data.Owner)}</Author>
      <Description margin={!expand}>
        {truncateDescription(data, data.Description, expand ? 30 : 12)}
      </Description>
      {expand && data.Tags && (
        <TagContainer>
          <Tags tags={data.Tags} />
        </TagContainer>
      )}
    </ResourceContainer>
  )
}

export default ResourcePreview
